
<div class="skeleton-container" :style="skeletonStyle"></div>
